import PropTypes from "prop-types";
import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { Menu, Close } from "./styles";

const MenuDrawer = ({ anchor = "right", open = false, onClose, children, slideProps }) => {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: "90%" } }}
      ModalProps={{ keepMounted: true }}
      SlideProps={slideProps}
    >
      <Menu>
        <Close>
          <IconButton alt="Close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Close>

        {children}
      </Menu>
    </Drawer>
  );
};

MenuDrawer.propTypes = {
  anchor: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  slideProps: PropTypes.shape({}),
};

export default MenuDrawer;
